import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getBusinessSegmentName } from '@mews-commander/legacy-entities/src/ducks/businessSegments';

const BusinessSegmentName = ({ businessSegmentName }: $TSFixMe) =>
    businessSegmentName ? <>{businessSegmentName}</> : null;

export default connect(
    createStructuredSelector({
        // @ts-expect-error $TSFixMeError: No overload matches this call.
        businessSegmentName: getBusinessSegmentName,
    })
)(BusinessSegmentName);
